<template>
    <div class="outer-box" >
      <h4>Release lock on phone number</h4>
  
      <div class="inner-box" style="text-align: left; width: 500px;">
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="mobile number with country code"
          v-model="phoneNo"
        />
        <button class="btn btn-primary mt-4" @click="fetchReleasePhoneLogs" :disabled="!phoneNo || processing">
          <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
          <span v-else> Unlock History </span>
        </button>
        <button class="btn btn-primary mt-4 ml-3" @click="resetVerification" :disabled="!response || releaseProcessing || disableRelease">
          <moon-loader v-if="releaseProcessing" :loading="true" size="21px" color="#fafafa" />
          <span v-else> Release Phone Number </span>
        </button>
        <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
      </div>
    </div>
  </template>
  
  <script>
  import { OnboardingService } from "@/services";
  import * as moment from "moment";
  export default {
    data() {
      return {
        moment,
        phoneNo: '',
        phoneNoCopy: '',
        processing: false,
        releaseProcessing: false,
        response: null,
        disableRelease: true
      };
    },
    methods: {
      async fetchReleasePhoneLogs(){
        try {
            this.processing = true
            let phoneNo = this.phoneNo.split(" ").join('')
            const {data} = await OnboardingService.fetchReleasePhoneLogs(phoneNo);

            if(data.success) {
                const logs = data.result.data.map(ele=> {
                    return {
                        companyId: ele.companyId,
                        agent: ele.agent,
                        createdAt: moment(ele.createdAt).format('DD-MMM-YYYY HH:mm:ss Z')
                    }
                })

                this.response = {
                    total: data.result.total,
                    data: logs
                }
            } else {
                this.response = data.message
            }
            this.phoneNoCopy = this.phoneNo
            this.disableRelease = false

            this.processing = false;
        } catch (error) {
            this.processing = false;
            console.error(error);
        }
        
      },
      async resetVerification(){
        try {
            this.releaseProcessing = true
            let phoneNo = this.phoneNo.split(" ").join('')
            const body = {
                releasePhoneLock: phoneNo,
            }
            const {data} = await OnboardingService.resetVerification(body);

            this.response = data

            this.releaseProcessing = false;
        } catch (error) {
            this.releaseProcessing = false;
            console.error(error);
        }
        
      },
    },
    watch:{
        phoneNo(val){ 
            val = val.split(" ").join('')
            if(val !== this.phoneNoCopy) {
                this.disableRelease = true
            }
        }
    }
  }
  </script>
  
  <style>
  </style>
  